(function () {
  var CFG = window.TmPaymentConfig || {};
  var GATE_ENABLED = CFG.GATE_ENABLED !== false;
  var STORAGE_CC = 'tm-cart-wants-cc-site';
  var STORAGE_METHOD = 'tm-cart-pay-method';
  var STORAGE_BANK = 'tm-cart-bank';
  var STORAGE_INST = 'tm-cart-installment';
  var COMMISSION_RE = /kart\s*ile|tek\s*çekim|komisyon/i;
  var FEE_ITEM_RE = /kart\s*ile|komisyon|upcharge/i;
  var FEE_PROP_RE = /^\s*komisyon/i;
  var MIN_INSTALLMENT = CFG.MIN_INSTALLMENT || 20000;
  var SINGLE_SITE_COMM = CFG.SINGLE_SITE_COMM || 12;
  var _suppressObserver = false;
  var _feeSettleCallback = null;

  var METHODS = {
    cc: {
      cartAttr: 'Kredi Kartı — Site',
      notice: 'Bir sonraki ödeme sayfasında <strong>Kredi kartı</strong> seçin. %12 komisyon sepete eklenir.',
      noticeClass: 'tm-cc-gate__notice--cc'
    },
    mailorder: {
      cartAttr: 'Mail Order Taksit',
      notice: 'Banka ve taksit seçin. Bir sonraki ödeme sayfasında <strong>Mail Order</strong> seçin.',
      noticeClass: 'tm-cc-gate__notice--warn'
    },
    eft: {
      cartAttr: 'Havale / EFT',
      notice: 'Bir sonraki ödeme sayfasında <strong>EFT / Havale</strong> seçin. Komisyon uygulanmaz.',
      noticeClass: 'tm-cc-gate__notice--free'
    },
    crypto: {
      cartAttr: 'Kripto (USDT)',
      notice: 'Bir sonraki ödeme sayfasında <strong>Kripto (USDT)</strong> seçin. Komisyon uygulanmaz.',
      noticeClass: 'tm-cc-gate__notice--free'
    }
  };

  var FEE_LABELS = CFG.FEE_LABELS || {
    site: 'Komisyon Site',
    mo3: 'Komisyon Taksit 3',
    mo4: 'Komisyon Taksit 4',
    mo5: 'Komisyon Taksit 5',
    mo6: 'Komisyon Taksit 6',
    mo7: 'Komisyon Taksit 7',
    mo8: 'Komisyon Taksit 8',
    mo9: 'Komisyon Taksit 9',
    mo10: 'Komisyon Taksit 10',
    mo11: 'Komisyon Taksit 11',
    mo12: 'Komisyon Taksit 12'
  };

  function round50(n) { return Math.ceil(n / 50) * 50; }
  function tl(n) {
    return n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function getPayMethod() { return sessionStorage.getItem(STORAGE_METHOD) || ''; }
  function setPayMethod(method) {
    if (method) sessionStorage.setItem(STORAGE_METHOD, method);
    else sessionStorage.removeItem(STORAGE_METHOD);
  }
  function getBank() { return sessionStorage.getItem(STORAGE_BANK) || ''; }
  function setBank(bankKey) {
    if (bankKey) sessionStorage.setItem(STORAGE_BANK, bankKey);
    else sessionStorage.removeItem(STORAGE_BANK);
  }
  function getInstallment() {
    try {
      var raw = sessionStorage.getItem(STORAGE_INST);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }
  function setInstallment(plan) {
    if (plan) sessionStorage.setItem(STORAGE_INST, JSON.stringify(plan));
    else sessionStorage.removeItem(STORAGE_INST);
  }

  /* ----------------------- Upcharge fee checkboxes ----------------------- */

  function getCheckboxLabelText(input) {
    var label = input.closest('label');
    if (!label && input.id) label = document.querySelector('label[for="' + input.id + '"]');
    if (label) return (label.textContent || '').trim();
    return input.parentElement ? (input.parentElement.textContent || '').trim() : '';
  }

  function classifyFeeCheckbox(input) {
    var text = getCheckboxLabelText(input);
    if (!text || !COMMISSION_RE.test(text)) return null;
    if (/site\s*üzerinden|tek\s*çekim\s*site|komisyon\s*site/i.test(text)) return 'site';
    var monthMatch = text.match(/taksit\s*(\d+)|(\d+)\s*ay/i);
    if (monthMatch) {
      var months = parseInt(monthMatch[1] || monthMatch[2], 10);
      return CFG.feeKeyForMailOrder ? CFG.feeKeyForMailOrder(months) : ('mo' + months);
    }
    if (/komisyon/i.test(text) && !/taksit/i.test(text)) return 'site';
    return null;
  }

  function findAllFeeCheckboxes() {
    var boxes = [];
    document.querySelectorAll('.cart-item input[type="checkbox"], #cart-items input[type="checkbox"]').forEach(function (input) {
      if (input.closest('tm-cc-gate')) return;
      var key = classifyFeeCheckbox(input);
      if (!key) return;
      boxes.push({ input: input, key: key });
    });
    return boxes;
  }

  function getFeeBlockRoot(el) {
    var root = el;
    var node = el.parentElement;
    while (node && !node.classList.contains('cart-item__info') && !node.classList.contains('cart-item__details')) {
      if (node.classList.contains('cart-item')) break;
      root = node;
      node = node.parentElement;
    }
    return root;
  }

  function hideFeeBlocks() {
    document.querySelectorAll('.cart-item__info *').forEach(function (el) {
      if (el.closest('tm-cc-gate')) return;
      if (el.children.length > 2) return;
      if (/aşağıdaki\s*seçeneği\s*işaretleyiniz/i.test((el.textContent || '').trim())) {
        getFeeBlockRoot(el).classList.add('tm-upcharge-hidden');
      }
    });
    findAllFeeCheckboxes().forEach(function (box) {
      getFeeBlockRoot(box.input).classList.add('tm-upcharge-hidden');
      var label = box.input.closest('label');
      if (label) label.classList.add('tm-fee-hidden');
    });
    document.querySelectorAll('.cart-item__variants dl div').forEach(function (row) {
      var dt = row.querySelector('dt');
      if (dt && /komisyon/i.test(dt.textContent || '')) {
        row.classList.add('tm-upcharge-hidden');
      }
    });
  }

  function toggleFeeCheckbox(input, checked) {
    if (!input || input.checked === checked) return;
    input.checked = checked;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function feeKeyForMethod(methodKey, inst) {
    if (methodKey === 'cc') return 'site';
    if (methodKey === 'mailorder' && inst && inst.months) {
      return CFG.feeKeyForMailOrder ? CFG.feeKeyForMailOrder(inst.months) : ('mo' + inst.months);
    }
    return null;
  }

  function hasCommissionOption() {
    return findAllFeeCheckboxes().length > 0;
  }

  function isCommissionChecked() {
    return findAllFeeCheckboxes().some(function (b) { return b.input.checked; });
  }

  function isCorrectFeeActive(methodKey, inst) {
    var wanted = feeKeyForMethod(methodKey, inst);
    var boxes = findAllFeeCheckboxes();
    if (!wanted) {
      return !boxes.length || boxes.every(function (box) { return !box.input.checked; });
    }
    var matching = boxes.filter(function (box) { return box.key === wanted; });
    if (!matching.length) return false;
    return matching.every(function (box) { return box.input.checked; });
  }

  function setActiveFee(methodKey, inst) {
    var wanted = feeKeyForMethod(methodKey, inst);
    var boxes = findAllFeeCheckboxes();
    if (!boxes.length) return !wanted;
    hideFeeBlocks();
    boxes.forEach(function (box) {
      toggleFeeCheckbox(box.input, !!(wanted && box.key === wanted));
    });
    if (!wanted) return true;
    return boxes.some(function (box) {
      return box.key === wanted && box.input.checked;
    });
  }

  function expectedGross(net, methodKey, inst) {
    if (!net) return 0;
    if (methodKey === 'cc') return calcSiteTotal(net);
    if (methodKey === 'mailorder' && inst) return calcInstTotal(net, inst.commission);
    return net;
  }

  function finishFeeApply() {
    if (typeof _feeSettleCallback === 'function') {
      var cb = _feeSettleCallback;
      _feeSettleCallback = null;
      cb();
    }
  }

  function applyCommissionWithRetry(methodKey, inst, attempt) {
    if ((attempt || 0) === 0) _suppressObserver = true;
    hideFeeBlocks();
    setActiveFee(methodKey, inst);

    fetchCart().then(function (cart) {
      var wanted = feeKeyForMethod(methodKey, inst);
      var net = getPreviewNet(cart);
      var gross = getCartGross(cart);
      var settled = false;

      if (!wanted) {
        settled = isCorrectFeeActive(methodKey, inst) &&
          (Math.abs(gross - net) < 2 || gross <= net * 1.01);
      } else {
        var expected = expectedGross(net, methodKey, inst);
        settled = isCorrectFeeActive(methodKey, inst) &&
          Math.abs(gross - expected) < 300;
      }

      if (!settled && (attempt || 0) < 15) {
        setTimeout(function () {
          applyCommissionWithRetry(methodKey, inst, (attempt || 0) + 1);
        }, 350);
        return;
      }

      rememberBaseNet(cart);
      refreshCartUI();
      _suppressObserver = false;
      hideFeeBlocks();
      finishFeeApply();
    }).catch(function () {
      _suppressObserver = false;
      finishFeeApply();
    });
  }

  function refreshCartUI() {
    var cartItems = document.querySelector('cart-items');
    if (cartItems && typeof cartItems.refresh === 'function') {
      cartItems.refresh();
    }
  }

  /* ----------------------- Cart API helpers ----------------------- */

  function routes() { return (window.theme && theme.routes) || {}; }

  function fetchCart() {
    return fetch(routes().cart || '/cart.js', {
      headers: { Accept: 'application/json' }
    }).then(function (r) { return r.json(); });
  }

  function isFeeItem(item) {
    return FEE_ITEM_RE.test((item.product_title || item.title || '').toLowerCase());
  }

  function getItemBaseCents(item) {
    if (isFeeItem(item)) return 0;
    var line = item.line_price || 0;
    var origLine = item.original_line_price || 0;
    var unitBase = (item.original_price || item.price || 0) * (item.quantity || 1);
    var vals = [line, origLine, unitBase].filter(function (v) { return v > 0; });
    if (!vals.length) return 0;
    return Math.min.apply(null, vals);
  }

  function getCartGross(cart) {
    var gross = 0;
    (cart.items || []).forEach(function (item) {
      if (isFeeItem(item)) return;
      gross += (item.line_price || 0) / 100;
    });
    return gross;
  }

  function computeBaseNet(cart) {
    var total = 0;
    (cart.items || []).forEach(function (item) {
      total += getItemBaseCents(item);
    });
    return total / 100;
  }

  function getPreviewNet(cart) {
    if (!cart || !cart.items || !cart.items.length) return 0;
    var base = computeBaseNet(cart);
    var gross = getCartGross(cart);
    if (base > 0 && gross > base * 1.015) return base;
    return gross > 0 ? gross : base;
  }

  function rememberBaseNet() {
    /* no-op: preview net is always derived from the current cart */
  }

  function getCartNet(cart) {
    return getPreviewNet(cart);
  }

  function changeLineProperties(itemKey, properties) {
    return fetch(routes().cartChange || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: itemKey, properties: properties })
    }).then(function (r) { return r.json(); });
  }

  function stripKomisyonPropertiesFromCart() {
    return fetchCart().then(function (cart) {
      var tasks = [];
      (cart.items || []).forEach(function (item) {
        if (isFeeItem(item)) return;
        var props = item.properties || {};
        var cleaned = {};
        var changed = false;
        Object.keys(props).forEach(function (key) {
          var val = props[key];
          if (FEE_PROP_RE.test(key) || (typeof val === 'string' && FEE_PROP_RE.test(val))) {
            changed = true;
            return;
          }
          cleaned[key] = val;
        });
        if (changed) tasks.push(changeLineProperties(item.key, cleaned));
      });
      return tasks.length ? Promise.all(tasks) : undefined;
    }).catch(function () {});
  }

  function applyPaymentFee(methodKey, inst) {
    return new Promise(function (resolve) {
      _feeSettleCallback = resolve;
      stripKomisyonPropertiesFromCart().then(function () {
        applyCommissionWithRetry(methodKey, inst, 0);
      });
    });
  }

  /* ----------------------- Calculation helpers ----------------------- */

  function calcInstTotal(net, commission) {
    return round50(net * (1 + commission / 100));
  }

  function calcSiteTotal(net) {
    return round50(net * (1 + SINGLE_SITE_COMM / 100));
  }

  function setCheckoutBlocked(block) {
    document.querySelectorAll('[name="checkout"]').forEach(function (btn) {
      btn.classList.toggle('checkout-blocked', block);
      if (block) btn.setAttribute('aria-disabled', 'true');
      else btn.removeAttribute('aria-disabled');
    });
  }

  /* ----------------------- Sanitize broken Upcharge prop ----------------------- */

  var BROKEN_PROP_RE = /\{\{|\}\}|amount_no_decimals/i;

  function cleanLineProperties(properties, stripKomisyon) {
    var cleaned = {};
    var changed = false;
    Object.keys(properties || {}).forEach(function (key) {
      var val = properties[key];
      if (val == null || val === '') return;
      if (stripKomisyon && FEE_PROP_RE.test(key)) { changed = true; return; }
      if (typeof val === 'string' && BROKEN_PROP_RE.test(val)) { changed = true; return; }
      if (typeof val === 'string' && FEE_PROP_RE.test(val)) { changed = true; return; }
      cleaned[key] = val;
    });
    return { cleaned: cleaned, changed: changed };
  }

  function sanitizeCartLineProperties() {
    return fetchCart().then(function (cart) {
      var tasks = [];
      (cart.items || []).forEach(function (item) {
        var result = cleanLineProperties(item.properties, true);
        if (!result.changed) return;
        tasks.push(changeLineProperties(item.key, result.cleaned));
      });
      return tasks.length ? Promise.all(tasks) : undefined;
    }).catch(function () {});
  }

  /* ----------------------- Bank / installment HTML ----------------------- */

  function bankOptionsHtml() {
    var html = '<option value="">— Banka seçin —</option>';
    if (!CFG.BANKS) return html;
    Object.keys(CFG.BANKS).forEach(function (key) {
      html += '<option value="' + key + '">' + CFG.BANKS[key].label + '</option>';
    });
    return html;
  }

  function installmentOptionsHtml(bankKey, net) {
    var html = '<option value="">— Taksit seçin —</option>';
    if (!bankKey) return html;
    if (net < MIN_INSTALLMENT) {
      return html + '<option value="" disabled>20.000 TL altı taksit yapılmaz</option>';
    }
    (CFG.monthsForBank ? CFG.monthsForBank(bankKey) : []).forEach(function (m) {
      var comm = CFG.commission ? CFG.commission(m) : 0;
      var total = calcInstTotal(net, comm);
      var monthly = round50(total / m);
      html += '<option value="' + m + '|' + comm + '">' +
        m + ' ay — ' + tl(total) + ' ₺ (Aylık: ' + tl(monthly) + ' ₺, %' + comm + ')' +
        '</option>';
    });
    return html;
  }

  function saveCartAttributes(attrs) {
    return fetch(routes().cartUpdate || '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  }

  function saveCartAttribute(methodKey) {
    var meta = METHODS[methodKey];
    if (!meta) return Promise.resolve();
    return saveCartAttributes({
      'Ödeme yöntemi': meta.cartAttr,
      'Mail Order Banka': '',
      'Mail Order Taksit': '',
      'Mail Order Komisyon': ''
    });
  }

  function saveMailOrderAttributes(inst) {
    if (!inst) return Promise.resolve();
    return saveCartAttributes({
      'Ödeme yöntemi': 'Mail Order — ' + inst.bankLabel + ' — ' + inst.months + ' ay (%' + inst.commission + ')',
      'Mail Order Banka': inst.bankLabel,
      'Mail Order Taksit': inst.months + ' ay',
      'Mail Order Komisyon': '%' + inst.commission
    });
  }

  function goToCheckout() {
    window.location.href = '/checkout';
  }

  /* ----------------------- Custom element ----------------------- */

  if (!customElements.get('tm-cc-gate')) {
    class TmCcGate extends HTMLElement {
      constructor() {
        super();
        this.onSubmit = this.handleSubmit.bind(this);
        this.forms = [];
        this._cartNet = 0;
        this._submitting = false;
        this._refreshing = false;
      }

      connectedCallback() {
        if (!GATE_ENABLED) {
          this.hidden = true;
          setCheckoutBlocked(false);
          hideFeeBlocks();
          this.mo = new MutationObserver(hideFeeBlocks);
          var cartItems = document.getElementById('cart-items');
          if (cartItems) this.mo.observe(cartItems, { childList: true, subtree: true });
          document.addEventListener('on:cart:add', hideFeeBlocks);
          document.addEventListener('on:line-item:change', hideFeeBlocks);
          document.addEventListener('on:cart-drawer:after-open', hideFeeBlocks);
          return;
        }
        this.render();
        this.bind();
        this.sync();
        document.addEventListener('on:cart:add', this.sync.bind(this));
        document.addEventListener('on:line-item:change', this.onCartRefresh.bind(this));
        document.addEventListener('on:cart-drawer:after-open', this.onDrawerOpen.bind(this));
        this.mo = new MutationObserver(hideFeeBlocks);
        var cartItems = document.getElementById('cart-items');
        if (cartItems) this.mo.observe(cartItems, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        if (this.mo) this.mo.disconnect();
        var self = this;
        this.forms.forEach(function (f) { f.removeEventListener('submit', self.onSubmit); });
      }

      onDrawerOpen() {
        hideFeeBlocks();
        this.sync();
      }

      onCartRefresh() {
        if (_suppressObserver) return;
        if (this._refreshing) return;
        this._refreshing = true;
        hideFeeBlocks();
        var self = this;
        var method = getPayMethod();
        var inst = getInstallment();
        this.loadCartNet().then(function () {
          if (method === 'cc') {
            return applyPaymentFee('cc', null).then(function () {
              return self.loadCartNet();
            });
          }
          if (method === 'mailorder' && inst) {
            return applyPaymentFee('mailorder', inst).then(function () {
              return self.loadCartNet();
            });
          }
        }).then(function () {
          var m = getPayMethod();
          if (m && METHODS[m]) {
            self.showNotice(m);
            if (m === 'mailorder') self.refreshInstallmentPreview();
          }
        }).finally(function () { self._refreshing = false; });
      }

      render() {
        this.innerHTML =
          '<p class="tm-cc-gate__title">Ödeme yönteminiz</p>' +
          '<p class="tm-cc-gate__text">Aşağıdan ödeme yönteminizi seçin. Bir sonraki ödeme sayfasında aynı yöntemi seçeceksiniz.</p>' +
          '<div class="tm-cc-gate__options" role="radiogroup" aria-label="Ödeme yöntemi">' +
            '<label class="tm-cc-gate__opt" data-method="eft">' +
              '<input type="radio" name="tm-cart-pay-method" value="eft">' +
              '<span class="tm-cc-gate__opt-body"><span class="tm-cc-gate__opt-title">🏦 Havale / EFT</span><span class="tm-cc-gate__opt-sub">Komisyonsuz</span></span>' +
            '</label>' +
            '<label class="tm-cc-gate__opt" data-method="cc">' +
              '<input type="radio" name="tm-cart-pay-method" value="cc">' +
              '<span class="tm-cc-gate__opt-body"><span class="tm-cc-gate__opt-title">💳 Kredi kartı (site)</span><span class="tm-cc-gate__opt-sub">%12 komisyon sepete eklenir</span></span>' +
            '</label>' +
            '<label class="tm-cc-gate__opt" data-method="mailorder">' +
              '<input type="radio" name="tm-cart-pay-method" value="mailorder">' +
              '<span class="tm-cc-gate__opt-body"><span class="tm-cc-gate__opt-title">🏦 Mail Order (taksit)</span><span class="tm-cc-gate__opt-sub">Banka seç → taksit seç → ödeme</span></span>' +
            '</label>' +
            '<label class="tm-cc-gate__opt" data-method="crypto">' +
              '<input type="radio" name="tm-cart-pay-method" value="crypto">' +
              '<span class="tm-cc-gate__opt-body"><span class="tm-cc-gate__opt-title">🪙 Kripto (USDT)</span><span class="tm-cc-gate__opt-sub">Komisyonsuz</span></span>' +
            '</label>' +
          '</div>' +
          '<div class="tm-cc-gate__inst" hidden>' +
            '<label class="tm-cc-gate__inst-label" for="tm-cart-bank-select">Banka seçin</label>' +
            '<select class="tm-cc-gate__inst-select" id="tm-cart-bank-select"></select>' +
            '<label class="tm-cc-gate__inst-label tm-cc-gate__inst-label--sub" for="tm-cart-inst-select">Taksit seçin</label>' +
            '<select class="tm-cc-gate__inst-select" id="tm-cart-inst-select" disabled><option value="">— Önce banka seçin —</option></select>' +
            '<div class="tm-cc-gate__inst-preview"></div>' +
          '</div>' +
          '<div class="tm-cc-gate__notice" hidden></div>';

        this.noticeEl = this.querySelector('.tm-cc-gate__notice');
        this.optionEls = this.querySelectorAll('.tm-cc-gate__opt');
        this.instPanel = this.querySelector('.tm-cc-gate__inst');
        this.bankSelect = this.querySelector('#tm-cart-bank-select');
        this.instSelect = this.querySelector('#tm-cart-inst-select');
        this.instPreview = this.querySelector('.tm-cc-gate__inst-preview');
        if (this.bankSelect) this.bankSelect.innerHTML = bankOptionsHtml();
      }

      bind() {
        var self = this;
        this.addEventListener('change', function (e) {
          if (e.target.matches('input[name="tm-cart-pay-method"]')) self.selectMethod(e.target.value);
          if (e.target.id === 'tm-cart-bank-select') self.onBankChange(e.target.value);
          if (e.target.id === 'tm-cart-inst-select') self.onInstallmentChange(e.target.value);
        });
        ['cart-drawer-form', 'cart'].forEach(function (id) {
          var form = document.getElementById(id);
          if (!form) return;
          form.addEventListener('submit', self.onSubmit);
          self.forms.push(form);
        });
        document.querySelectorAll('[name="checkout"]').forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            if (!self.shouldBlockSelection()) return;
            e.preventDefault();
            e.stopPropagation();
            alert(self.blockMessage());
          }, true);
        });
      }

      loadCartNet() {
        var self = this;
        return fetchCart().then(function (cart) {
          self._cartNet = getCartNet(cart);
          return self._cartNet;
        }).catch(function () { return self._cartNet || 0; });
      }

      onBankChange(bankKey) {
        setBank(bankKey || '');
        setInstallment(null);
        if (this.instPreview) this.instPreview.innerHTML = '';
        if (!this.instSelect) return;
        if (!bankKey) {
          this.instSelect.disabled = true;
          this.instSelect.innerHTML = '<option value="">— Önce banka seçin —</option>';
        } else {
          this.instSelect.disabled = false;
          this.instSelect.innerHTML = installmentOptionsHtml(bankKey, this._cartNet);
        }
        var self = this;
        applyPaymentFee('mailorder', null).then(function () {
          return self.loadCartNet();
        }).then(function () {
          if (bankKey && self.instSelect) {
            self.instSelect.innerHTML = installmentOptionsHtml(bankKey, self._cartNet);
          }
          self.updateCheckoutState();
        });
      }

      onInstallmentChange(val) {
        var bankKey = getBank();
        if (!val || !bankKey) {
          setInstallment(null);
          if (this.instPreview) this.instPreview.innerHTML = '';
          this.updateCheckoutState();
          return;
        }
        var parts = val.split('|');
        var plan = {
          bank: bankKey,
          bankLabel: CFG.bankLabel ? CFG.bankLabel(bankKey) : bankKey,
          months: parseInt(parts[0], 10),
          commission: parseFloat(parts[1])
        };
        setInstallment(plan);
        this.refreshInstallmentPreview();
        var self = this;
        saveMailOrderAttributes(plan);
        applyPaymentFee('mailorder', plan).then(function () {
          return self.loadCartNet();
        }).then(function () {
          self.refreshInstallmentPreview();
          self.showNotice('mailorder');
          self.updateCheckoutState();
        });
      }

      restoreMailOrderSelections() {
        var bankKey = getBank();
        if (this.bankSelect) this.bankSelect.value = bankKey || '';
        if (!bankKey) {
          if (this.instSelect) {
            this.instSelect.disabled = true;
            this.instSelect.innerHTML = '<option value="">— Önce banka seçin —</option>';
          }
          return;
        }
        if (this.instSelect) {
          this.instSelect.disabled = false;
          this.instSelect.innerHTML = installmentOptionsHtml(bankKey, this._cartNet);
          var saved = getInstallment();
          if (saved && saved.months) {
            this.instSelect.value = saved.months + '|' + saved.commission;
          }
        }
        if (this.instSelect && this.instSelect.value) {
          this.refreshInstallmentPreview();
        }
      }

      selectMethod(methodKey) {
        if (!METHODS[methodKey]) return;
        setPayMethod(methodKey);
        this.updateSelectedUI(methodKey);
        var self = this;
        this.loadCartNet().then(function () {
          if (methodKey === 'mailorder') {
            if (self.instPanel) self.instPanel.hidden = false;
            self.restoreMailOrderSelections();
            var inst = getInstallment();
            if (inst) {
              saveMailOrderAttributes(inst);
              applyPaymentFee('mailorder', inst).then(function () {
                return self.loadCartNet();
              }).then(function () {
                self.showNotice('mailorder');
                self.updateCheckoutState();
              });
            } else {
              applyPaymentFee('mailorder', null).then(function () {
                return self.loadCartNet();
              }).then(function () {
                self.showNotice('mailorder');
                self.updateCheckoutState();
              });
            }
          } else {
            if (self.instPanel) self.instPanel.hidden = true;
            setBank('');
            setInstallment(null);
            saveCartAttribute(methodKey);
            applyPaymentFee(methodKey, null).then(function () {
              return self.loadCartNet();
            }).then(function () {
              self.showNotice(methodKey);
              self.updateCheckoutState();
            });
          }
        });
      }

      updateSelectedUI(methodKey) {
        this.optionEls.forEach(function (el) {
          var radio = el.querySelector('input[type="radio"]');
          var selected = el.dataset.method === methodKey;
          el.classList.toggle('is-selected', selected);
          if (radio) radio.checked = selected;
        });
      }

      refreshInstallmentPreview() {
        var plan = getInstallment();
        if (!plan || !this.instPreview) return;
        var net = this._cartNet;
        if (!(net > 0)) {
          this.instPreview.innerHTML = '';
          return;
        }
        var total = calcInstTotal(net, plan.commission);
        var monthly = round50(total / plan.months);
        this.instPreview.innerHTML =
          plan.bankLabel + ' — ' + plan.months + ' ay<br>' +
          'Beklenen toplam: <b>' + tl(total) + ' ₺</b> — Aylık: <b>' + tl(monthly) + ' ₺</b> (%' + plan.commission + ')';
      }

      showNotice(methodKey) {
        var meta = METHODS[methodKey];
        if (!this.noticeEl || !meta) return;
        this.noticeEl.hidden = false;
        this.noticeEl.className = 'tm-cc-gate__notice ' + meta.noticeClass;
        this.noticeEl.innerHTML = meta.notice;
        var net = this._cartNet;
        if (methodKey === 'cc' && net > 0) {
          this.noticeEl.innerHTML += '<br>Beklenen toplam: <strong>' + tl(calcSiteTotal(net)) + ' ₺</strong> (%' + SINGLE_SITE_COMM + ')';
        }
        if (methodKey === 'mailorder' && getInstallment() && net > 0) {
          var inst = getInstallment();
          this.noticeEl.innerHTML += '<br>Beklenen toplam: <strong>' + tl(calcInstTotal(net, inst.commission)) + ' ₺</strong>';
        }
        if (methodKey === 'eft' || methodKey === 'crypto') {
          this.noticeEl.innerHTML += '<br><span style="font-weight:700;">Kredi kartı ile öderseniz komisyon eksik kalır.</span>';
        }
      }

      shouldBlockSelection() {
        var method = getPayMethod();
        if (!method) return true;
        if (method === 'mailorder' && (!getBank() || !getInstallment())) return true;
        return false;
      }

      updateCheckoutState() {
        setCheckoutBlocked(this.shouldBlockSelection());
      }

      blockMessage() {
        var method = getPayMethod();
        if (!method) return 'Lütfen ödeme yönteminizi seçin.';
        if (method === 'mailorder') {
          if (!getBank()) return 'Mail order için banka seçin.';
          if (!getInstallment()) return 'Mail order için taksit seçin.';
        }
        return 'Lütfen ödeme yönteminizi kontrol edin.';
      }

      handleSubmit(e) {
        var submitter = e.submitter;
        if (!submitter || submitter.getAttribute('name') !== 'checkout') return;
        if (this.shouldBlockSelection()) {
          e.preventDefault();
          alert(this.blockMessage());
          return;
        }
        e.preventDefault();
        if (this._submitting) return;
        this._submitting = true;
        var self = this;
        sanitizeCartLineProperties().then(function () {
          return stripKomisyonPropertiesFromCart();
        }).finally(function () {
          self._submitting = false;
          goToCheckout();
        });
      }

      sync() {
        var cartItems = document.getElementById('cart-items');
        if (!cartItems || cartItems.dataset.empty === 'true') {
          this.hidden = true;
          setCheckoutBlocked(false);
          return;
        }
        this.hidden = false;
        hideFeeBlocks();
        var self = this;
        this.loadCartNet().then(function () {
          if (sessionStorage.getItem(STORAGE_CC) === '1') {
            sessionStorage.removeItem(STORAGE_CC);
            self.selectMethod('cc');
            return;
          }
          var method = getPayMethod();
          if (method && METHODS[method]) {
            self.updateSelectedUI(method);
            if (method === 'mailorder') {
              if (self.instPanel) self.instPanel.hidden = false;
              self.restoreMailOrderSelections();
            } else if (self.instPanel) {
              self.instPanel.hidden = true;
            }
            var inst = getInstallment();
            if (method === 'cc' || (method === 'mailorder' && inst)) {
              applyPaymentFee(method, inst).then(function () {
                return self.loadCartNet();
              }).then(function () {
                self.showNotice(method);
                if (method === 'mailorder') self.refreshInstallmentPreview();
                self.updateCheckoutState();
              });
            } else {
              self.showNotice(method);
              self.updateCheckoutState();
            }
            return;
          }
          self.selectMethod('eft');
        });
      }
    }

    customElements.define('tm-cc-gate', TmCcGate);
  }

  document.addEventListener('click', function (e) {
    if (e.target && e.target.id === 'tm-ix-checkout') {
      sessionStorage.setItem(STORAGE_CC, '1');
    }
  }, true);
})();
